export class CountryModel {
  countryCode: string;
  phoneCode: string;
}

export const countryList: CountryModel[] = [
  {
    countryCode: 'lt',
    phoneCode: '+370',
  },
  { countryCode: 'no', phoneCode: '+47' },
];
